import { createContext, useContext, type ReactNode, type RefObject } from "react";

export type GameCanvasOverlayLayout = {
  overlayRootRef: RefObject<HTMLDivElement | null>;
  canvasRef: RefObject<HTMLCanvasElement | null>;
  viewportRef: RefObject<HTMLDivElement | null>;
  displayScale: number;
};

const GameCanvasOverlayLayoutContext = createContext<GameCanvasOverlayLayout | null>(null);

export function GameCanvasOverlayLayoutProvider({
  value,
  children,
}: {
  value: GameCanvasOverlayLayout;
  children: ReactNode;
}) {
  return (
    <GameCanvasOverlayLayoutContext.Provider value={value}>
      {children}
    </GameCanvasOverlayLayoutContext.Provider>
  );
}

export function useGameCanvasOverlayLayout(): GameCanvasOverlayLayout {
  const layout = useContext(GameCanvasOverlayLayoutContext);
  if (!layout) {
    throw new Error(
      "useGameCanvasOverlayLayout must be used within GameCanvasOverlayLayoutProvider",
    );
  }
  return layout;
}
